import { Box } from '@chakra-ui/react';
import { OptionalTooltip } from 'components/OptionalTooltip/OptionalTooltip';
import styles from './BetaTag.module.css';
export const BetaTag = ({
  tooltip
}: {
  tooltip?: string;
}) => <OptionalTooltip content={tooltip} data-sentry-element="OptionalTooltip" data-sentry-component="BetaTag" data-sentry-source-file="BetaTag.tsx">
    <Box className={styles.betaTag} data-sentry-element="Box" data-sentry-source-file="BetaTag.tsx">BETA</Box>
  </OptionalTooltip>;